"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_const_awsS3_keys = exports.SHu_const_awsS3_buckets = void 0;
exports.SHu_const_awsS3_buckets = {
    main: "selltosimply-cdn",
};
exports.SHu_const_awsS3_keys = {
    airtable_streetview: "airtable/properties/street-view",
    aio_properties_streetview: "aio/properties/street-view",
};
